export default __webpack_public_path__ + "static/partner-tube-1-84814244770b53f2e0784c0f4a720357.png";